// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".p-background{position:fixed;top:0px;left:0px;z-index:-1;height:100vh;width:100vw}@media (min-width: 1024px){.p-background__mobile{display:none}}.p-background__desktop{display:none}@media (min-width: 1024px){.p-background__desktop{display:block}}.p-background__desktop, .p-background__mobile{height:100%;width:100%;-o-object-fit:cover;object-fit:cover}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
